import * as React from 'react';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Constants, ImagePath, ImageRelativePath } from '../../constants';
import { Avatar, CardMedia, Grid2 } from '@mui/material';
import ProgressBar from './ProgressBar';
import { useDialog } from '../../hook/useDialog';
import MainDialogBox from '../Dialog/MainDialogBox';
import { useMenu } from '../../hook/useMenu';
import MenuPopover from '../Menu/MenuPopover';
import AttendanceTableList from '../../../features/student/AttendanceList';
import { Formik, Field, Form } from "formik";
import { TextFormField } from '../formfields/TextFormField';
import RatingFormField from '../formfields/RatingFormField';
import * as Yup from "yup";
import { CustomIconButton } from '../../utils/IconButton';
import { Icon } from '@iconify/react/dist/iconify.js';
import CardContainer from '../../utils/CardContainer';
import { MovingText } from '../../utils/MovingText';
import { useEffect, useRef } from 'react';
import useCourseIdStore from '../../../store/useCourseIdStore';
import ViewCourseDetail from './ViewCourseDetail';
import { useToaster } from '../../utils/ToasterProvider';
import { useNavigate } from 'react-router-dom';
import { useOfflineMeetingDetail, useOnlineMeetingDetail } from '../../../assets/api/UseStudentGetApi';
import MeetingCard from './MeetingCard';
import { getCourseStatusColor } from './CurrentClassCard';
import { SlotCard1 } from '../../../features/student/StudentOnlineCourseDetail';
import { formatToAmPm } from '../../formatter';
import { usePostCourseReview } from '../../../assets/api/useStudentPostHooks';

const AllCoursesCard = ({ item, status }) => {
    const {
        title,
        start_date,
        end_date,
        batch_name,
        course_status,
        category_name,
        cover_image,
        apartments_id,
        slug,
        batch_id,
        event_id,
        online,
        course_type,
        apartment_name,
        trainer_id,
        course_id
    } = item
    const navigate = useNavigate();
    const { open, handleClickOpen, handleClose } = useDialog();
    const { open: openAlt, handleClickOpen: handleAltOpen, handleClose: handleAltClose } = useDialog();
    const { open: openProgress, handleClickOpen: handleProgressOpen, handleClose: handleProgressClose } = useDialog();
    const { open: openschedule, handleClickOpen: handleScheduleOpen, handleClose: handleScheduleClose } = useDialog();
    const { open: openOfflineSchedule, handleClickOpen: handleOfflineScheduleOpen, handleClose: handleOfflineScheduleClose } = useDialog();
    const { open: openDetail, handleClickOpen: handleOpenDetail, handleClose: handleDetailClose } = useDialog();
    const { anchorEl, openMenu, handleMenuOpen, handleMenuClose } = useMenu();
    const { data: MeetingDetail } = useOnlineMeetingDetail({ batch_name: batch_name })
    const { data: OfflineMeetingDetail, isLoading: isOfflineMeetingDetailLoading } = useOfflineMeetingDetail({ apartments_id: apartments_id, course_id: event_id })
    const { showToaster } = useToaster();
    const { courseId, setCourseId } = useCourseIdStore();

    const mutation = usePostCourseReview(() => handleAltClose());

    const handlePushchased = () => {
        setCourseId(event_id);
        handleOpenDetail();
    }
    const dialogRef = useRef(null);
    useEffect(() => {
        if (openDetail && dialogRef.current) {
            setTimeout(() => {
                dialogRef.current.scrollTo({ top: 0, behavior: "smooth" });
            }, 100);
        }
    }, [courseId, openDetail]);

    // Memoized status-based properties
    const { statusColor, buttonText, handleDialogOpen } = React.useMemo(() => {
        switch (course_status) {
            case "Ongoing Class":
                return {
                    statusColor: "yellow.main",
                    buttonText: "Access your Progress",
                    handleDialogOpen: handleProgressOpen,
                };
            case "Upcoming Class":
                return {
                    statusColor: "blue.main",
                    buttonText: "View Course Details",
                    handleDialogOpen: handleAltOpen,
                };
            case "Completed Class":
                return {
                    statusColor: "green.main",
                    buttonText: "Add Review",
                    handleDialogOpen: handleAltOpen,
                };
            default:
                return {
                    statusColor: "inherit",
                    buttonText: "View Details",
                    handleDialogOpen: handleAltOpen,
                };
        }
    }, [course_status, handleClickOpen, handleAltOpen]);

    const menuItems = React.useMemo(() => {
        const items = [];

        if (course_status === "Ongoing Class" || course_status === "Completed Class") {
            items.push({
                label: "View Attendance",
                onClick: () => {
                    handleClickOpen();
                    handleMenuClose();
                },
            });
        }

        // ✅ ADD THIS BLOCK
        if (course_status === "Completed Class") {
            items.push({
                label: "Add Review",
                onClick: () => {
                    handleAltOpen();
                    handleMenuClose();
                },
            });
        }
        return items;
    }, [course_status, handleClickOpen, handleMenuClose, handleScheduleOpen, showToaster, online]);



    const validationSchema = Yup.object().shape({
        rating: Yup.number()
            .min(1, "Please select at least 1 star") // Ensures at least 1 star is selected
            .max(5, "Rating cannot exceed 5 stars")
            .required("Rating is required"),

        message: Yup.string()
            .trim()
            .min(10, "Feedback must be at least 10 characters")
            .max(300, "Feedback cannot exceed 300 characters")
            .required("Feedback is required"),
    });
    const handleSubmit = (values) => {
        const payload = {
            courseId: course_id || event_id,
            trainerId: trainer_id || 1, // Fallback to 1 if not available, as in typical testing
            text: values.message,
            level: values.rating
        };
        mutation.mutate(payload);
    }

    const Reaction = [
        { emoji: Constants.customImages.VeryPoorEmoji, emojiName: "Very Poor" },
        { emoji: Constants.customImages.PoorEmoji, emojiName: "Poor" },
        { emoji: Constants.customImages.GoodEmoji, emojiName: "Good" },
        { emoji: Constants.customImages.VeryPoorEmoji, emojiName: "Very Poor" },
        { emoji: Constants.customImages.PerfectEmoji, emojiName: "Perfect" }
    ]
    const courses = [
        {
            id: 1,
            title: "Introduction to Machine Learning",
            content: "Learn what machine learning is and its basic types: supervised, unsupervised, and reinforcement learning Understand the process of training a model with data to make predictions or decisions",
            progress: 100
        },
        {
            id: 2,
            title: "Data Preparation and Preprocessing",
            content: "Explore how to collect, clean, and prepare data for training models. Learn the importance of feature selection and splitting data into training and testing sets.", progress: 30
        },
        {
            id: 3,
            title: "Building and Training Models",
            content: "Learn how to choose appropriate algorithms (like linear regression or decision trees) and train models on data.Understand concepts like overfitting, underfitting, and model evaluation",
            progress: 70
        },
        {
            id: 4,
            title: "Model Deployment and Maintenance",
            content: "Learn how to deploy machine learning models into real-world applications and integrate them into systems.",
            progress: 50
        },
    ];

    const [selectedDate, setSelectedDate] = React.useState(null);

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const details = [
        ...(online === 1
            ? [
                { label: "Batch", value: batch_name },

            ]
            : []),
        { label: "From", value: start_date },



    ];

    const additionalDetails = [

        { label: "To", value: end_date },
        ...(online !== 1
            ? [
                { label: "Apartment", value: apartment_name },

            ]
            : []),
        { label: "status", value: course_status },

    ];

    return (
        <>
            <CardContainer>
                <CardMedia
                    sx={{
                        width: { lg: "35%", xs: "100%" },
                        borderRadius: "15px",
                        height: { lg: "auto", xs: "200px" }
                    }}
                    image={`${ImagePath}${ImageRelativePath}${cover_image}`}
                    alt={title}
                />
                <CardContent sx={{ flex: 1, px: { lg: "15px", xs: "0" } }}>
                    <Box sx={{ display: "grid", gridTemplateColumns: "auto max-content", alignItems: "center" }}>
                        <Box sx={{ minWidth: 0 }}>
                            <MovingText text={title} variant={"h5"} />
                            <Typography variant='h6' color='secondary.light'>{category_name}</Typography>
                        </Box>
                        <Box sx={{ minWidth: "max-content" }}>
                            <CustomIconButton
                                onClick={handleMenuOpen}
                                icon={<Icon icon="ph:dots-three-outline-vertical-fill" color='#D9D9D9' height="30" />}
                            />
                        </Box>
                    </Box>

                    <Box sx={{ my: 1 }}>
                        {[details, additionalDetails].map((group, index) => (
                            <Box key={index}>
                                {group.map(({ label, value }, idx) => (
                                    <Typography key={idx} fontSize={"13px"} variant="body2">
                                        {label} : {" "}
                                        {value ? (
                                            label === "status" ? (
                                                <>
                                                    <Typography
                                                        component="span"
                                                        fontSize={"13px"}
                                                        sx={{ color: getCourseStatusColor(course_status) }}
                                                    >
                                                        {value}
                                                    </Typography>

                                                </>

                                            ) : (
                                                value
                                            )
                                        ) : (
                                            ""
                                        )}
                                    </Typography>
                                ))}

                            </Box>

                        ))}
                    </Box>
                    <Box my={2}> <ProgressBar /></Box>
                    <Button variant='contained' fullWidth
                        onClick={() => { online === 1 ? navigate(`/student/onlinecoursedetail/${slug}/${batch_id}`) : course_type === 9 ? navigate(`/student/summercampcoursedetail/${slug}/${apartments_id}/${event_id}`) : navigate(`/student/coursedetail/${slug}/${apartments_id}/${event_id}`) }}
                    >
                        View Detail
                    </Button>
                </CardContent>
            </CardContainer>

            <MainDialogBox open={open} handleClose={handleClose}>
                <AttendanceTableList apartmentId={apartments_id} courseId={event_id} />
            </MainDialogBox>


            <MainDialogBox open={openAlt} handleClose={handleAltClose} width={"35%"}>
                <Formik initialValues={{ rating: 0, message: "" }} validationSchema={validationSchema} onSubmit={handleSubmit}>
                    {() => (
                        <Form>
                            <RatingFormField name="rating" />
                            <Typography variant='h5' color='blue.main' fontWeight={500} textAlign={"center"} my={2}>Together, We Can Create a Better Experience</Typography>
                            <Field
                                name="message"
                                component={TextFormField}
                                multiline
                                rows={3}
                            />

                            <Box mt={2}>
                                <Button variant='contained' fullWidth type='submit' >Submit</Button>
                            </Box>

                        </Form>
                    )}
                </Formik>

            </MainDialogBox>


            <MainDialogBox open={openProgress} handleClose={handleProgressClose} padding={"30px 40px"}>


                {courses.map((course, index) => (
                    <Box key={index} sx={{ display: "flex", alignItems: "stretch" }}>

                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "12px" }}>

                            <Box
                                sx={{
                                    width: "12px",
                                    height: "12px",
                                    bgcolor: "blue.main",
                                    borderRadius: "50%",
                                    border: "4px solid #D9D9D9"
                                }}
                            />
                            <Box sx={{ width: "2px", bgcolor: "#D9D9D9", flexGrow: 1 }} />
                        </Box>
                        <Box sx={{ ml: 3, flex: 1, pb: "5%" }}>
                            <Typography variant="h3">
                                {course.title}
                            </Typography>
                            <Typography variant="body2" mt={1} mb={2}>
                                {course.content}
                            </Typography>
                            <ProgressBar value={course.progress} bgcolor={"blue.main"} islarge={true} />
                            {
                                course.progress === 100 && (
                                    <Box sx={{ display: "flex", justifyContent: "start", alignItems: "start", gap: { lg: "10%", xs: "10px" } }}>

                                        {Reaction.map((item, index) => (
                                            <Box mt={3} key={index}>
                                                <Avatar
                                                    src={item.emoji}
                                                    sx={{
                                                        width: { lg: "60px", xs: "60px" },
                                                        height: { lg: "60px", xs: "60px" },
                                                        transition: "transform 0.3s ease-in-out",
                                                        cursor: "pointer",
                                                        "&:hover": { transform: "scale(1.2)" },


                                                    }}

                                                // onClick={(e) => e.target.style.transform = "scale(1.2)"}
                                                // onMouseLeave={(e) => e.target.style.transform = "scale(1)"}

                                                />
                                                <Typography variant='h4' fontWeight={500} textAlign={"center"}>
                                                    {item.emojiName}
                                                </Typography>
                                            </Box>

                                        ))}
                                    </Box>
                                )
                            }

                        </Box>
                    </Box>


                ))}

            </MainDialogBox>


            <MenuPopover
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleMenuClose}
                menuItems={menuItems}
            />


            <MainDialogBox MainDialogBox open={openDetail} handleClose={handleDetailClose} ref={dialogRef} >
                <ViewCourseDetail ispurchase={true} />
            </MainDialogBox >


            <MainDialogBox open={openschedule} handleClose={handleScheduleClose} width={"60%"}>
                {
                    MeetingDetail?.status && <>


                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box>
                                <Typography variant='h3' mb={1} fontWeight={900}>{title}</Typography>
                                <Typography variant='body2'>Online Class</Typography>
                            </Box>
                            <Box>
                                <Typography variant='body2' mb={1}>Course Start Date : {MeetingDetail?.start_date}</Typography>
                                <Typography variant='body2'>Course End Date : {MeetingDetail?.end_date}</Typography>
                            </Box>
                        </Box>
                        {
                            MeetingDetail?.data?.map((item, index) => (
                                <MeetingCard item={item} key={index} detail={MeetingDetail} />
                            ))
                        }
                    </>

                }
                {
                    !MeetingDetail?.status && <Typography>Schedule is not Created  yet</Typography>
                }
            </MainDialogBox>

            <MainDialogBox open={openOfflineSchedule} handleClose={handleOfflineScheduleClose} width={"60%"}>
                <Box>
                    <Box>
                        <Typography variant='h3' mb={1} fontWeight={900}>{title}</Typography>
                        <Typography variant='body2'>Apartment Name : {apartment_name}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", gap: 2 }}>
                        <Typography variant='body2' mb={1}>Course Start Date : {OfflineMeetingDetail?.data?.start_date}</Typography>
                        <Typography variant='body2'>Course End Date : {OfflineMeetingDetail?.data?.end_date}</Typography>
                    </Box>
                </Box>

                {OfflineMeetingDetail?.data?.sessions?.map((item) => (
                    <SlotCard1 day={item?.day} timing={`${formatToAmPm(item?.start_time)}-${formatToAmPm(item?.end_time)}`} />
                ))}
            </MainDialogBox>

        </>
    );
}

export default AllCoursesCard;
